export default __webpack_public_path__ + "static/media/Document.f6655e4d.svg";